<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $t("stocktakesummary") }}</div>
      </div>
    </div>
    <br />

    <div class="white-wrapper">
      <div class="row">
        <div class="col-md-5">
          <div class="dropdown-curve-container">
            <label :class="selectedCinema.length > 0 ? 'shift-up' : ''"
              >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
            >
            <div class="d-flex justify-content-center align-items-center">
              <div class="dropdown-curve-container">
                <multiselect
                  :options="cinemasList"
                  v-model="selectedCinema"
                  :searchable="true"
                  label="cine_name"
                  track-by="cine_id"
                  :placeholder="'Select CInema'"
                  :showLabels="false"
                  :multiple="true"
                  group-values="Cinemas"
                  group-label="label"
                  :group-select="true"
                >
                </multiselect>
              </div>
            </div>
          </div>
          <p class="error_message">
            <span v-if="submitted && selectedCinema.length == 0"
              >Please Select Cinema.</span
            >
          </p>
        </div>

        <div class="col-md-2">
          <div class="input-material">
            <div class="add-datepicker">
              <button
                @click="fromDate = null"
                class="btn-clearDate"
                v-if="fromDate"
              >
                ✖
              </button>
              <Datepicker
                :monday-first="true"
                v-model="fromDate"
                typeable
              ></Datepicker>
              <label :class="fromDate ? 'active' : ''"
                >{{ $t("from") }} {{ $t("date") }}</label
              >
            </div>
          </div>
          <p class="error_message">
            <span v-if="submitted && fromDate == null"
              >Please Select From Date.</span
            >
          </p>
        </div>

        <div class="col-md-2">
          <div class="input-material">
            <div class="add-datepicker">
              <button
                @click="toDate = null"
                class="btn-clearDate"
                v-if="toDate"
              >
                ✖
              </button>
              <Datepicker
                :monday-first="true"
                v-model="toDate"
                typeable
              ></Datepicker>
              <label :class="toDate ? 'active' : ''"
                >{{ $t("to") }} {{ $t("date") }}</label
              >
            </div>
          </div>
          <p class="error_message">
            <span v-if="submitted && toDate == null"
              >Please Select To Date.</span
            >
          </p>
        </div>

        <div class="col-md-2">
          <button class="btn-blue" @click.prevent.stop="getStockTakeLogs()">
            {{ $t("fetch") }}
          </button>
        </div>

        <div
          v-if="groupedData && groupedData.length > 0"
          class="d-flex justify-content-end align-items-center w-100 mr-4 mb-2"
        >
          <div>{{ $t("download") }} as:</div>
          <a
            download
            style="cursor: pointer"
            target="_blank"
            title="Download as Excel"
            @click="getStockTakeLogs('Y')"
          >
            <img
              class="mx-1"
              height="25"
              src="@/assets/img/icons/excel.svg"
              width="25"
            />
          </a>
        </div>
      </div>
      <div class="swc-report">
        <table class="swc-report-table">
          <thead>
            <tr class="bg-lightgrey">
              <th>Cinema Name</th>
              <th>RM Category</th>
              <th>{{ "System Calculated Stock (SCS)" }}</th>
              <th>{{ "Counted Stock (CS)" }}</th>
              <th>{{ "Variance (CS -SCS)" }}</th>
              <th>{{ "SCS Value (SCSV)" }}</th>
              <th>{{ "CS Value (CSV)" }}</th>
              <th>{{ "Variance Value" }}</th>
            </tr>
          </thead>

          <tbody v-if="groupedData.length > 0">
            <template v-for="(cinemaGrp, cinemaIndex) in groupedData">
              <template v-for="(catGrp, catIndex) in cinemaGrp.categoryArray">
                <tr :key="cinemaIndex + '_' + catIndex">
                  <td>{{ cinemaGrp.cinema_name }}</td>
                  <td>{{ catGrp.category_name }}</td>
                  <!--System Calculated Stock (SCS)-->
                  <td class="text-right">
                    {{
                      currFormat(
                        catGrp.itemsArray.reduce(function (
                          accumulator,
                          { system_calculated_stock }
                        ) {
                          return (
                            accumulator + parseFloat(system_calculated_stock)
                          );
                        },
                        0)
                      )
                    }}
                  </td>
                  <td class="text-right">
                    {{
                      currFormat(
                        catGrp.itemsArray.reduce(function (
                          accumulator,
                          { counted_stock }
                        ) {
                          return accumulator + parseFloat(counted_stock);
                        },
                        0)
                      )
                    }}
                  </td>
                  <td class="text-right">
                    {{
                      currFormat(
                        catGrp.itemsArray.reduce(function (
                          accumulator,
                          { variance }
                        ) {
                          return accumulator + parseFloat(variance);
                        },
                        0)
                      )
                    }}
                  </td>
                  <td class="text-right">
                    {{
                      currFormat(
                        catGrp.itemsArray.reduce(function (
                          accumulator,
                          { system_calculated_stock_value }
                        ) {
                          return (
                            accumulator +
                            parseFloat(system_calculated_stock_value)
                          );
                        },
                        0)
                      )
                    }}
                  </td>

                  <td class="text-right">
                    {{
                      currFormat(
                        catGrp.itemsArray.reduce(function (
                          accumulator,
                          { counted_stock_value }
                        ) {
                          return accumulator + parseFloat(counted_stock_value);
                        },
                        0)
                      )
                    }}
                  </td>

                  <td class="text-right">
                    {{
                      currFormat(
                        catGrp.itemsArray.reduce(function (
                          accumulator,
                          { variance_value }
                        ) {
                          return accumulator + parseFloat(variance_value);
                        },
                        0)
                      )
                    }}
                    <!-- {{
                      currFormat(
                        catGrp.itemsArray.reduce(function (
                          accumulator,
                          { variance_percent }
                        ) {
                          return accumulator + parseFloat(variance_percent);
                        },
                        0)
                      )
                    }} -->
                  </td>
                </tr>
              </template>
              <tr :key="cinemaIndex + '_1'" class="bg-lightgrey">
                <td>Total</td>
                <td></td>
                <!--System Calculated Stock (SCS)-->
                <td class="text-right">
                  {{
                    currFormat(
                      cinemaGrp.categoryArray.reduce(
                        (acc, catGrp) =>
                          acc +
                          catGrp.itemsArray.reduce(function (
                            accumulator,
                            { system_calculated_stock }
                          ) {
                            return (
                              accumulator + parseFloat(system_calculated_stock)
                            );
                          },
                          0),
                        0
                      )
                    )
                  }}
                </td>
                <td class="text-right">
                  {{
                    currFormat(
                      cinemaGrp.categoryArray.reduce(
                        (acc, catGrp) =>
                          acc +
                          catGrp.itemsArray.reduce(function (
                            accumulator,
                            { counted_stock }
                          ) {
                            return accumulator + parseFloat(counted_stock);
                          },
                          0),
                        0
                      )
                    )
                  }}
                </td>
                <td class="text-right">
                  {{
                    currFormat(
                      cinemaGrp.categoryArray.reduce(
                        (acc, catGrp) =>
                          acc +
                          catGrp.itemsArray.reduce(function (
                            accumulator,
                            { variance }
                          ) {
                            return accumulator + parseFloat(variance);
                          },
                          0),
                        0
                      )
                    )
                  }}
                </td>
                <td class="text-right">
                  {{
                    currFormat(
                      cinemaGrp.categoryArray.reduce(
                        (acc, catGrp) =>
                          acc +
                          catGrp.itemsArray.reduce(function (
                            accumulator,
                            { system_calculated_stock_value }
                          ) {
                            return (
                              accumulator +
                              parseFloat(system_calculated_stock_value)
                            );
                          },
                          0),
                        0
                      )
                    )
                  }}
                </td>
                <td class="text-right">
                  {{
                    currFormat(
                      cinemaGrp.categoryArray.reduce(
                        (acc, catGrp) =>
                          acc +
                          catGrp.itemsArray.reduce(function (
                            accumulator,
                            { counted_stock_value }
                          ) {
                            return (
                              accumulator + parseFloat(counted_stock_value)
                            );
                          },
                          0),
                        0
                      )
                    )
                  }}
                </td>
                <td class="text-right">
                  {{
                    currFormat(
                      cinemaGrp.categoryArray.reduce(
                        (acc, catGrp) =>
                          acc +
                          catGrp.itemsArray.reduce(function (
                            accumulator,
                            { variance_value }
                          ) {
                            return accumulator + parseFloat(variance_value);
                          },
                          0),
                        0
                      )
                    )
                  }}

                  <!-- {{
                    currFormat(
                      cinemaGrp.categoryArray.reduce(
                        (acc, catGrp) =>
                          acc +
                          catGrp.itemsArray.reduce(function (
                            accumulator,
                            { variance_percent }
                          ) {
                            return accumulator + parseFloat(variance_percent);
                          },
                          0),
                        0
                      )
                    )
                  }} -->
                </td>
              </tr>
            </template>
            <tr class="w-100" v-if="groupedData.length == 0">
              <td colspan="14">
                <h6 class="mb-0">
                  No Records Found
                  <br />
                </h6>
              </td>
            </tr>
          </tbody>

          <tbody v-else>
            <tr>
              <td colspan="14">
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import PosFnbService from "@/services/PosFnbService";
import MasterService from "@/services/MasterService";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: {
    NoRecords,
  },
  data() {
    return {
      submitted: false,
      Cinemas: [],
      cinemasList: [],
      CinemasCopy: [],
      selectedCinema: [],
      fromDate: new Date(),
      toDate: new Date(),
      totalVariance: 0,
      stock_take_logs: [],
      searchCinema: "",
      selectedid: null,
      stock_take_date: null,
      stockTakePDF: null,
      stockTakeExcel: null,
      groupedData: [],
    };
  },
  beforeMount() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    this.getCinemas(obj);
  },
  mounted() {},
  methods: {
    getCinemas: function (cine_id) {
      MasterService.GetCinemasByRoles({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.CinemasCopy = data.Records;
            this.cinemasList = [
                {
                  label: "All",
                  Cinemas: data.Records,
                },
              ];
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        });
    },
    getStockTakeLogs: function (isExcelDownload = "N") {
      this.submitted = true;
      this.groupedData = [];
      if (!this.selectedCinema || !this.selectedCinema.length) {
        return this.$toasted.show("Please Select Cinema");
      } else if (!this.fromDate) {
        return this.$toasted.show("Please Select From Date");
      } else if (!this.toDate) {
        return this.$toasted.show("Please Select To Date");
      } else {
        let loader = this.$loading.show();
        PosFnbService.GetStockTakeLogSummary({
          cinemaIds: this.selectedCinema.map((cine) => cine.cine_id),
          fromDate: this.fromDate,
          toDate: this.toDate,
          isExcel: isExcelDownload || "N",
        })
          .then((response) => {
            const { data } = response;
            if (data.status) {
              if (data.Records && data.Records.length > 0) {
                this.groupedData = data.structuredData;
                if (data.FinalExcelFile && isExcelDownload == "Y") {
                  console.log('HERE');
                  window.open(this.BASE_URL + data.FinalExcelFile, "_blank");
                }
              } else {
                this.$toasted.show(data.message);
              }
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError)
          .finally(() => {
            setTimeout(() => loader.hide(), 1000);
          });
      }
    },
  },
};
</script>

<style scoped>
.swc-report-table th,
.swc-report-table td {
  border: 1px solid #000000;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/StockComponents/stockTakeLogSummary.vue